<template>
  <div v-loading="pageLoading">
    <div class="info-detail">
      <div class="info-header">
        <div class="title">{{title}}</div>
        <div class="subinfo">發佈時間：{{ activityTime }}</div>
        <div class="subinfo">活動時間：{{ eventTime }}</div>
        <div class="subinfo">發佈人員：{{ name }}</div>
        <div class="subinfo">ESG活動：{{ esgType == 0 ? '是' : '否' }}</div>
      </div>
      <div class="border"/>
      <div>
        <div class="content">{{content}}</div>
      </div>
      <div class="border"/>
      <div>
        <div class="media-block" v-if="img.length > 0">
          <div class="label">資訊圖片</div>
          <img v-for="(item, index) in img"
              :key="index"
              :src="item" />
        </div>
        <div class="video-block" v-if="isVideo">
          <div class="label">活動視頻</div>
          <div class="video-box">
            <video-player class="video-player vjs-custom-skin"
                          ref="videoPlayer"
                          :playsinline="true"
                          :options="playerOptions"></video-player>
          </div>
        </div>
        <div class="media-block pdf" v-if="file">
          <div class="label">活动文件</div>
          <div class="pdf-content">
            <el-button type="primary" @click="download">下載
              <i class="el-icon-download el-icon--right"></i>
            </el-button>
            <iframe v-if="file.endsWith('.pdf')" :src="file" class="pdf-preview" width="100%" height="600px"/>
          </div>
        </div>
      </div>
    </div>
    <el-button class="btn"
               @click="$router.back(-1)">返 回</el-button>
  </div>
</template>

<script>
import 'video.js/dist/video-js.css';
// import 'videojs-flash'
import { videoPlayer } from 'vue-video-player'; // 有多个输出值，引入花括号
export default {
  components: {
    videoPlayer
  },
  data () {
    return {
      pageLoading: false,

      title: '',
      activityTime: '',
      eventTime: '',
      name: '',
      content: '',
      img: [],
      esgType: null,
      file: '',
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: '',
            src: '' //视频url地址
          }
        ],
        // poster: '../../static/image/thumb_1_1380_460_20181009043014983386.jpg', //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      },
      isVideo: false
    };
  },
  methods: {
    download () {
      location.href = this.file;
    }
  },
  mounted () {
    $('#pageHead').text('活動詳情');
  },
  created () {
    this.pageLoading = true
    var id = sessionStorage.getItem('activityId');
    this.axios({
      url: '/manage/getManActivity',
      params: {
        id: id
      }
    }).then(res => {
      if (res) {
        let msg = res.result[0];
        this.title = msg.activityName;
        this.name = msg.manUserName;
        this.activityTime = msg.activityStartTime + ' —— ' + msg.activityEndTime;
        this.eventTime = msg.eventStartTime + ' —— ' + msg.eventEndTime;
        this.content = msg.content;
        this.img = msg.pictureFile ? msg.pictureFile.split(',') : []
        this.file = msg.contentFile;
        this.esgType = msg.esgType
        if (msg.videoFile) {
          this.playerOptions.sources[0].src = msg.videoFile;
          this.isVideo = true;
        }
      }
      this.pageLoading = false
    });
  }
};
</script>

<style scoped>
p {
  color: #999;
}
.border {
  width: 30%;
  margin: 24px auto;
  height: 1px;
  background: #ddd;
}
hr {
  border-bottom: none;
  border-top: 3px solid #999;
}
.btn {
  position: absolute;
  top: 90px;
  right: 45px;
}
img {
  max-width: 500px;
}
h4 {
  text-align: left;
  margin-left: 20%;
}
.video-box {
  max-width: 60%;
  margin: auto;
}
.title {
  margin-top: 12px;
  font-weight: 500;
  font-size: 28px;
  text-align: center;
}
.subinfo {
  color: #999;
  margin-top: 9px;
  text-align: center;
}
.content {
  text-indent: 42px;
  padding: 24px 0;
}
.media-block {
  display: flex;
  margin-bottom: 24px;
}
.label {
  width: 120px;
  font-weight: 550;
  text-align: right;
  margin-right: 12px;
}
.video-box {
  width: 90%;
}
.pdf-content {
  flex-grow: 100;
}
</style>
